'use client';

import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';
import gsap from 'gsap/all';
import { Text, Container, createQueryString } from '@weareconceptstudio/core';

//* Style
import BlogTemplateStyle from './style';

//*	Helpers
import { animationTitle } from '@/helpers/_animationTitle';

//* Components
import PostItem from '../components/Item';
import FilterPosts from '../components/Filter';
import Pagination from '@/components/Pagination';

const BlogTemplate = ({ pageData, categoryData, postsData }) => {
	//! Next Navigation
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const params = useParams();

	//! Refs
	const titleRef = useRef();
	const refSplit = useRef();
	const wrapperPosts = useRef();

	//! Animation
	useEffect(() => {
		const animation = gsap.to([...wrapperPosts.current.children[0].children], {
			opacity: 1,
			duration: 0.6,
			stagger: 0.17,
			delay: 0.5,
		});
		return () => {
			animation.revert();
		};
	}, [pathname, params.lang, searchParams, searchParams.get('catId'), searchParams.get('page'), wrapperPosts]);

	useEffect(() => {
		animationTitle({ element: titleRef.current, ref: refSplit });

		gsap.to('.filter-wrapper', {
			opacity: 1,
			duration: 0.3,
			ease: 'power2.out',
			delay: 0.4,
		});
	}, []);

	//! Filter
	const onFilterChange = useCallback(
		(type, typeId, multiple = false) => {
			const params = createQueryString({ type, typeId, multiple, searchParams });

			router.push(pathname + '?' + params);
		},
		[searchParams]
	);

	//! Post Item
	const dataPosts = useMemo(() => {
		return postsData.posts?.map((item) => {
			return (
				<div
					key={item.id}
					className={'col-6 col-m-12 opacity-zero'}>
					<PostItem {...item} />
				</div>
			);
		});
	}, [postsData]);

	return (
		<BlogTemplateStyle>
			<Container isSection>
				<div className='wrapper-title row'>
					<Text
						ref={titleRef}
						tag={'h1'}
						className={'uppercase h2 col-6 col-t-12 opacity-zero hidden-container'}>
						{pageData.title}
					</Text>
				</div>

				<div className='wrapper-navigation row'>
					<FilterPosts
						filterKey={'catId'}
						searchParams={searchParams}
						categoryData={categoryData}
						onFilterChange={onFilterChange}
						className={'col-6 col-t-12 opacity-zero filter-wrapper'}
					/>
				</div>

				<div className='wrapper-items'>
					<Container
						row
						full
						className={'wrapper-posts'}
						ref={wrapperPosts}>
						{dataPosts}
					</Container>

					<Pagination
						className='pagination-content'
						total={postsData.total}
						pageSize={postsData.perPage}
						pageNumbersToShow={4}
						onCategoryChange={onFilterChange}
					/>
				</div>
			</Container>
		</BlogTemplateStyle>
	);
};

export default BlogTemplate;
